import { gql, makeVar } from "@apollo/client";

export interface UserType {
  bio?: string;
  dateJoined: string;
  email: string;
  facebookUsername?: string;
  firstName: string;
  id: string;
  imageId?: string;
  instagramUsername?: string;
  isPublic: boolean;
  lastName: string;
  location: string;
  newsletter: boolean;
  phoneNumber?: string;
  pronouns: string;
  tiktokUsername?: string;
  twitterUsername?: string;
  username: string;
  websiteUrl?: string;
}

export const USER_FIELDS = gql`
  fragment UserFields on UserType {
    id
    bio
    dateJoined
    email
    facebookUsername
    imageId
    instagramUsername
    isPublic
    newsletter
    username
    firstName
    lastName
    location
    phoneNumber
    pronouns
    tiktokUsername
    twitterUsername
    websiteUrl
  }
`;

export const exploreCategory = makeVar("");
export const exploreCategoryModal = makeVar(false);
export const navBarEnabled = makeVar(false);
export const user = makeVar<UserType | null>(null);
